import { motion } from 'framer-motion'
import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import { modalSizeOptions, modalSizeOptionsStyle } from './constants'

export const Backdrop = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  padding: 1.5rem;
  align-items: center;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`

export const ModalContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colorsOptions.greys['grey-10']};
  border-radius: 16px;
  box-shadow:
    0px 34px 10px 0px rgba(20, 26, 33, 0),
    0px 22px 9px 0px rgba(20, 26, 33, 0),
    0px 12px 7px 0px rgba(20, 26, 33, 0.01),
    0px 6px 6px 0px rgba(20, 26, 33, 0.02),
    0px 1px 3px 0px rgba(20, 26, 33, 0.02);

  ${({ size = modalSizeOptions.MEDIUM }) => {
    const { colStart, colSpan } = modalSizeOptionsStyle[size]
    return `
      grid-column: ${colStart} / span ${colSpan};
    `
  }}
`

export const ModalContent = styled(motion.div)`
  overflow: auto;

  ${({ size = modalSizeOptions.MEDIUM, modalWidth }) => {
    const { maxHeight } = modalSizeOptionsStyle[size]

    if (!modalWidth) {
      return 'max-height: none'
    }

    return `
      max-height: ${modalWidth * maxHeight}px;
    `
  }}
`

export const ModalHeaderContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.85rem 0.5rem 0.85rem 1rem;
  gap: 0.5rem;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
`

export const ModalHeaderTitle = styled(motion.div)`
  font-variant-numeric: lining-nums proportional-nums;
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
    line-height: 20.8px; /* 130% */
  letter-spacing: 0.2px;
`

// actions
export const ModalAction = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`

export const ModalRightAlignedAction = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`

export const ModalLeftAlignedAction = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
`
